import { Autocomplete, Multicomplete } from './components/autocomplete';
import { AnimalPicker } from "./components/animalPicker";
import { IndividualTable } from "./components/individualTable";
import Overlay from './components/overlay';
import {injectOverlay} from "./components/overlay";
import ModalDialog from "./components/modal_dialog";
import QRReader from "./components/QRReader";
import * as f from './utils/functions';
import tippy from 'tippy.js';
import {DraggableElement} from "./components/draggableElement";
import {STChart} from "./components/chart";

import jsQR from "jsqr";
import axios from "axios";
import Plyr from 'plyr';
import { tinykeys } from "tinykeys";
import {FramePage} from "./components/framePage";
import {HelPage} from "./components/helpage";
import {Discussion} from "./utils/discussion";
import {createRandomString} from "./utils/functions";
import { modalPrompt } from './components/modalPrompt';
import { DragndropOrder } from './components/dragndropOrder';
import { Toaster } from './components/toaster';
import { BgTaskNotifier } from './components/bgTaskNotifier';
import flatpickr from "flatpickr";
import { TankTypeCheck } from './utils/tank_type';


// Export třídy a funkcí
window.ModalDialog = ModalDialog;
window.modalPrompt = modalPrompt;
window.DragndropOrder = DragndropOrder;
window.Overlay = Overlay;
window.injectOverlay = injectOverlay;
window.jsQR = jsQR;
window.QRReader = QRReader;
window.Autocomplete = Autocomplete;
window.Multicomplete = Multicomplete;
window.AnimalPicker = AnimalPicker;
window.IndividualTable = IndividualTable;
window.DraggableElement = DraggableElement;
window.FramePage = FramePage;
window.bindEvent = f.bindEvent;
window.submitForm = f.submitForm;
window.markErrorFields = f.markErrorFields;
window.createNotification = f.createNotification;
window.formatErrorData = f.formatErrorData;
window.escapeSpecialCSSChars = f.escapeSpecialCSSChars;
window.updateURLParams = f.updateURLParams;
window.getURLParam = f.getURLParam;
window.createTippyTooltips = createTippyTooltips;
window.Plyr = Plyr;
window.tinykeys = tinykeys;
window.newChart = f.newChart;
// window.newSTChart = newSTChart;
window.STChart = STChart;
window.debounce = f.debounce;
window.hslToHex = f.hslToHex;
window.hexToHsl = f.hexToHsl;
window.humanReadableSize = f.humanReadableSize;
window.acGetValues = f.acGetValues;
window.acSetValues = f.acSetValues;
window.acClearValues = f.acClearValues;
window.getIndividualsIds = f.getIndividualsIds;
window.reloadComponent = f.reloadComponent;
window.changeLocation = f.changeLocation;
window.switchTab = f.switchTab;
window.createRandomString = f.createRandomString;
window.getSelectedValues = f.getSelectedValues;
window.hydrateDropdowns = f.hydrateDropdowns;
window.AutoIncrementor = f.AutoIncrementor;
window.HelPage = HelPage;
window.Discussion = Discussion;
window.TankTypeCheck = TankTypeCheck;
window.static_files_url = "https://static.st-zeta.org/static/1.0.8"

const axiosInstance = axios.create();

// Hlavní doména (pro interní requesty)
const MAIN_DOMAIN = 'st-zeta.org';

// Interceptor pro přidání hlavičky jen na interní URL
axiosInstance.interceptors.request.use(config => {
  const url = config.url || '';
  const isInternal = url.startsWith('/') || url.includes(MAIN_DOMAIN) || url.startsWith('http://localhost');

  if (isInternal) {
    config.headers['X-Requested-With'] = "XMLHttpRequest";
  } else {
    delete config.headers['X-Requested-With'];
  }

  return config;
}, error => {
  return Promise.reject(error);
});

// Interceptor for assuring that blob error is converted to JSON for error handling to work correctly
axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const data = error.response?.data;

        if (
            data instanceof Blob &&
            data.type?.includes('application/json')
        ) {
            const text = await data.text();

            try {
                error.response.data = JSON.parse(text);
            } catch {
                error.response.data = text;
            }
        }

        return Promise.reject(error);
    }
);

window.axios = axiosInstance;


function createTippyTooltips(){
    document.querySelectorAll('[title]').forEach((element) => {
        element.setAttribute('data-tooltip', element.getAttribute('title'));
        element.removeAttribute('title'); // Remove title to avoid default tooltip
    });
    document.querySelectorAll('[data-tooltip]').forEach((el) => {
        if (el._tippy) {
            el._tippy.destroy();
        }
    });

    tippy('[data-tooltip]', {
        content(reference) {
            return reference.getAttribute('data-tooltip');
        },
        theme: "zeta",
        arrow: true,
        allowHTML: true,
        touch: ['hold', 500],
    });
}

document.addEventListener("DOMContentLoaded", () => {
    createTippyTooltips();
    if (document.getElementById("toast-container")) {
        window.toaster = new Toaster("#toast-container");
        window.bgTaskNotifier = new BgTaskNotifier();
        window.bgTaskNotifier.postFetch = (res) => {
            const toasts = window.toaster.getToastEls();
            const activeTaskIds = res.data.tasks.map(task => `bg_task-${parseInt(task.id)}`)
            toasts.forEach((toastEl) => {
                if (!activeTaskIds.includes(toastEl.dataset.toastId)) {
                    window.toaster.closeToast(toastEl, "success");
                    document.dispatchEvent(new CustomEvent("bgTaskCompleted"));
                }
            });
            res.data.tasks.forEach((task) => {
                window.toaster.appendToast(`${task.label_text || "Processing"}...`, `bg_task-${task.id}`)
            });
        }
        window.bgTaskNotifier.pollRunningTasks();
    }
})


window.addEventListener('location_changed', function (e) {
    if (e.defaultPrevented)
        return
    location.href = e.detail
})


document.addEventListener('formLoaded', function () {
    console.log("formLoaded event dispatched");
    document.querySelectorAll('.autocomplete:not(.finished)').forEach(element => new Autocomplete(element))
    document.querySelectorAll('.multicomplete:not(.finished)').forEach(element => new Multicomplete(element))
    document.querySelectorAll('.animal-picker:not(.finished)').forEach(element => new AnimalPicker(element))
    document.querySelectorAll('input.flatpickr-date-picker').forEach(element => flatpickr(element, {
        minDate: element.getAttribute("min"),
        maxDate: element.getAttribute("max"),
        dateFormat: "Y-m-d",
        allowInput: true,
        static: true,
        altInput: true,
        altFormat: "Y-m-d",
        ... element.dataset
    }))
    document.querySelectorAll('.flatpickr-range-picker').forEach(picker => {
        if (picker.value && picker.value.includes(',')) {
            picker.value = picker.value.replace(',', ' to ');
        }
        const changeHandler = function(selectedDates, dateStr, instance) {
            instance.element.value = dateStr.replace(' to ', ',');
            instance.altInput.value = dateStr.replace(' to ', '  -  ');
        }
        const fp = flatpickr(picker, {
            mode: "range",
            minDate: picker.getAttribute("min"),
            maxDate: picker.getAttribute("max"),
            dateFormat: "Y-m-d",
            static: true,
            altInput: true,
            altFormat: "Y-m-d",
            ... picker.dataset,
            onChange: changeHandler,
            onReady: changeHandler,
        })
    })

    const elements = document.querySelectorAll("[name]");
    elements.forEach(element => {
        element.addEventListener('change', function() {
            const relatedCheckbox = document.querySelector(`[name="use_${this.getAttribute("name")}"]`);
            if (relatedCheckbox) {
                relatedCheckbox.checked = true;
            }
        });
    });
    createTippyTooltips();
    document.dispatchEvent(new CustomEvent("componentsLoaded"));
});
